import { render, staticRenderFns } from "./CustomerFormV2.vue?vue&type=template&id=1b6dbd86&"
import script from "./CustomerFormV2.vue?vue&type=script&lang=js&"
export * from "./CustomerFormV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports